<!-- 项目文档移动跟复制 -->
<template>
  <div class="move_header">
    <el-dialog v-dialogDrag :visible.sync="visible" :close-on-click-modal="false" :close-on-press-escape="false"
      :before-close="handleClose" width="547px" top="80px" :title="title">
      <el-tree ref="localTree" :load="getlocalTree" :data="localTree" :props="defaultFileProps"
        :check-on-click-node="true" class="tree" lazy accordion highlight-current @node-click="handleNodeClick">
        <template #default="{ data }">
          <span>
            <img :src="icon" class="img" alt="文件" />
            {{ data.folderName }}
          </span>
        </template>
      </el-tree>
      <span slot="footer" class="dialog-footer">
        <span v-if="isShow" style="float:left">
          <el-checkbox v-model="isCopyAnnotation" :true-label="1" :false-label="0">同步复制批注信息</el-checkbox>
        </span>
        <span>
          <el-button size="small" @click="handleClose(true)">取消</el-button>
          <el-button type="primary" size="small" @click="confirmHandler()">确定</el-button>
        </span>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import docService from "@/CommonDP/service/doc-service";
import { mapState } from "vuex";
export default {
  props: {
    message: {
      type: Object,
      required: false,
      default: () => ({
        folderId: "folderId",

        isFolder: "isFolder"
      })
    },
    title: {
      type: String,
      required: false,
      default: ""
    }
  },
  data() {
    return {
      icon: require("@/CommonDP/assets/doc/folder_icon.png"),
      visible: true,
      localTree: [],
      defaultFileProps: {
        children: "childList",
        label: "folderName",
        isLeaf: "leaf"
      },
      isCopyAnnotation: 0,
      currentRow: {},
      parentId: ""
    };
  },
  computed: {
    ...mapState({
      enterpriseId: state => state.enterprise.enterpriseId,
      prjInfo: state => state.projectMg.prjObj,
      selectArr: state => state.XtDesign.selectArr
    }),
    // 判断所选问价夹是否有新建文件夹权限
    isAddFolder() {
      const { folderNew, folderType } = this.currentRow;
      const isShow = folderType ? folderType !== 13 && folderType !== 16 && folderType !== 14 : false;
      return folderNew === 1 && isShow;
    },
    // 判断所选问价夹是否有上传文件权限
    isUploaderFolder() {
      const { fileNew, folderType } = this.currentRow;
      const isShow = folderType ? folderType !== 15 && folderType !== 13 && folderType !== 16 && folderType !== 19 && folderType !== 14 : false;
      return fileNew === 1 && isShow;
    },
    // 是否显示同步复制批注信息
    isShow() {
      const { selectArr, title, message } = this;
      const single = title === "复制到" && message.isFolder === 0;
      const batch = title === "复制到" && selectArr.some(({ isFolder }) => isFolder === 0);
      return single || batch;
    }
  },

  async created() {},
  methods: {
    async getlocalTree(node, resolve) {
      // 取该文件一个区下面的
      const {
        prjInfo: { prjId },
        message: { rootId, folderId },
        selectArr
      } = this;
      const array = selectArr.map(item => {
        return item.rootId;
      }); // 多个文件rootid都一样。拿一个就行
      if (node.level === 0) {
        const params = {
          isRead: 1,
          priviAll: "1",
          noRightClickMenu: true,
          prjId
        };
        if (folderId !== "folderId") params.folderId = rootId;
        // 单个文件
        else params.folderId = array[0]; // 多个文件
        if (!params.folderId && params.folderId !== "0") {
          return resolve([]);
        }
        const result = await docService.queryTree(params);
        const list = result.data.filter(({ folderId }) => folderId !== "recycle").map(item => {
          const { childFolder = 0 } = item;
          return {
            ...item,
            leaf: childFolder === 0
          };
        });
        return resolve(list);
      } else {
        const params = {
          folderId: node.data.folderId,
          isRead: node.data.isRead,
          priviAll: node.data.priviAll,
          noRightClickMenu: true,
          prjId
        };
        if (!params.folderId && params.folderId !== "0") {
          return resolve([]);
        }
        const result = await docService.queryTree(params);
        const array = result.data.filter(({ isFolder }) => isFolder === 1).map(item => {
          const { childFolder = 0 } = item;
          return {
            ...item,
            leaf: childFolder === 0
          };
        }); // 过滤掉文件
        if (this.message.folderId !== "folderId") {
          // 单个文件
          const arrayList = array.filter(({ folderId }) => folderId !== this.message.folderId);
          return resolve(arrayList);
        } else {
          const twolist = array.filter(item => !this.selectArr.some(ele => ele.folderId === item.folderId));
          return resolve(twolist);
        }
      }
    },
    handleNodeClick(data) {
      this.currentRow = data;
      this.parentId = data.folderId;
    },
    handleClose() {
      this.visible = false;
      this.parentId = "";
      this.$parent.moveCopyShow = false;
    },
    async confirmHandler() {
      const {
        enterpriseId,
        isCopyAnnotation,
        prjInfo: { prjId },
        title,
        parentId
      } = this;

      const { folderId, isFolder } = this.message;

      const params = {
        enterpriseId,
        prjId,
        isCopyAnnotation,
        parentId
      };
      let file = false;
      let folder = false;
      if (folderId !== "folderId") params.ids = folderId.split();
      else {
        file = this.selectArr.some(item => item.isFolder === 0);// 文件
        folder = this.selectArr.some(item => item.isFolder === 1);// 文件夹
        params.ids = this.selectArr.map(item => {
          return item.folderId;
        });
      }
      if (parentId) {
        // 如果选择的是文件,就判断有没有上传的权限(文件需要上传)
        // 如果选择的是文件夹 就判断有没有新建文件夹的权限(文件夹需要新建)
        if (isFolder === 0 && !this.isUploaderFolder) {
          this.$message.warning("所选文件夹不具备上传权限");
        } else if (isFolder === 1 && !this.isAddFolder) {
          this.$message.warning("所选文件夹不具备新建文件夹权限");
        } else if (isFolder === 'isFolder' && file && !this.isAddFolder) {
          this.$message.warning("所选文件夹不具备上传权限");
        } else if (isFolder === 'isFolder' && folder && !this.isAddFolder) {
          this.$message.warning("所选文件夹不具备新建文件夹权限");
        } else {
          if (title === "移动到") {
            const res = await docService.docMove(params);
            if (res.result === "0") this.$message.success("移动成功");
          } else {
            const res = await docService.docCopy(params);
            if (res.result === "0") this.$message.success("复制成功");
          }
          this.$store.dispatch("XtDesignUpdateNodeList");
          this.$emit("callback");
          this.handleClose();
        }
      } else {
        this.$message.warning("没有选择指定文件夹");
      }
    },
    showCopyDialog() {
      this.visible = true;
    }
  }
};
</script>
<style lang="scss">
.move_header {
  .el-dialog__body {
    padding: 20px;
    height: 500px;
  }
  .el-dialog__header {
    line-height: 24px;
  }
  .el-dialog__footer {
    line-height: 32px;
  }
}
</style>
<style  lang="scss" scoped>
.img {
  height: 16px;
  width: 18px;
  user-select: none;
  vertical-align: bottom;
}
.tree {
  margin-top: 10px;
  max-height: 450px;
  overflow: auto;
}
</style>
